import React from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretLeft } from '@fortawesome/free-solid-svg-icons';
const CaretToggle = props => /*#__PURE__*/React.createElement(Button, {
  color: "link",
  onClick: props.onClick,
  className: "align-self-center ".concat(props.className)
}, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
  icon: props.open ? faCaretDown : faCaretLeft,
  color: "#007bff",
  size: "1x"
}));
export default CaretToggle;